import {
  useMultiMeterBarTooltipState,
  useMultiMeterBarVisibleSegmentsState,
} from './store/selectors.js';
import type { TooltipItem } from '../../../core/types/tooltip.js';
import { useFormatter } from '../../shared/context/FormatterContext.js';
import { TOOLTIP_VARIANT } from '../constants.js';
import { useMultiMeterBarChartTooltipData } from '../context/MultiMeterBarChartTooltipContext.js';

export const useMultiMeterBarChartTooltipItems = () => {
  const { content } = useMultiMeterBarTooltipState();

  const { formatter } = useFormatter();

  const visibleSegments = useMultiMeterBarVisibleSegmentsState();

  const { tooltipConfig } = useMultiMeterBarChartTooltipData();
  const isSharedTooltip = tooltipConfig.variant === TOOLTIP_VARIANT.Shared;

  if (!content && !isSharedTooltip) {
    return null;
  }

  if (content && !isSharedTooltip) {
    return [content];
  }

  const allItems: TooltipItem[] = visibleSegments.map((item) => ({
    id: item.id,
    name: item.name ?? '',
    values: [formatter(item.value)],
    color: { Default: item.color },
  }));

  return allItems;
};
